import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { types as coreTypes } from '@sitebuilder/core';
import { UsersApiClient } from '../api/usersApiClient';
import { ThunkResult } from './index';

export interface StateShape {
    users: coreTypes.Users | null;
    isUsersLoading: boolean;
    isUsersLoaded: boolean;
    UserLoadedError: boolean;
}

export const usersDefaultState: StateShape = {
    users: null,
    isUsersLoading: false,
    isUsersLoaded: false,
    UserLoadedError: false,
};

const usersApiClient = new UsersApiClient();

export const actionCreators = {
    loadUsersData: (
        authorizationToken: string | null | undefined
    ): ThunkResult<Promise<coreTypes.Users | undefined>> => {
        return async (dispatch) => {
            dispatch(usersSliceReducerActions.USERS_LOAD_START());

            try {
                const UsersResult = await usersApiClient.executeQuery(authorizationToken);

                if (UsersResult) {
                    dispatch(usersSliceReducerActions.USERS_LOAD_END({ UsersResult }));
                }

                return UsersResult;
            } catch (err: any) {
                console.error(err);
                dispatch(
                    usersSliceReducerActions.USERS_LOAD_END({ error: { message: err.message } })
                );
            }
        };
    },
};

const usersSlice = createSlice({
    name: 'query',
    initialState: usersDefaultState,
    reducers: {
        USERS_LOAD_START(draft) {
            draft.isUsersLoading = true;
        },
        USERS_LOAD_END(
            draft,
            action: PayloadAction<{ UsersResult?: coreTypes.Users; error?: any }>
        ) {
            const { UsersResult, error } = action.payload;
            draft.isUsersLoading = true;
            draft.isUsersLoading = true;
            draft.users = UsersResult || null;
            draft.UserLoadedError = error;
        },
    },
});

export const usersSliceReducerActions: any = usersSlice.actions;
export const usersReducer = usersSlice.reducer;
